<template>
      <div
          :style="{'--radio-button-color': $store.getters.getRadioButtonColor, '--radio-button-background-color': $store.getters.getRadioButtonBackgroundColor}">
          <div v-if="question.config.display_answers_inline">

            <label v-for="model in question.answers" v-bind:key="model.uid"
                   :for="question.uid"
                   v-bind:class="{ selected: model.selected }"
                   v-bind:id="'answer_label_' + model.uid"
                   v-on:click="setRadio(model.uid)"
                   :style="{'text-align': model.survey_icon_class ? 'center': '', 'margin-right': model.survey_icon_class ? '20px' : '0'}"
                   class="radio">

              <input style="display:none;" type="radio"
                     :name="question.uid"
                     :v-bind:id="model.uid"
                     :value="model.uid"
                     v-bind:checked="model.selected">

              <div v-if="model.survey_icon_class">
                <i :class="[model.survey_icon_class, model.selected ? 'selected-custom-icon' : '']"
                   style="padding-bottom:10px;padding-top:10px;"
                   class="custom-radio-icon">
                </i>
                <br>
                <b>{{ model.title }}</b>
              </div>

              <div class="radio__text" v-else :style="{'text-transform': question.config.answers_uppercase ? 'uppercase': ''}" v-bind:id="'answer_text_' + model.uid">
                <span>{{
                  model.title
                  }}</span>&nbsp;&nbsp;
              </div>
            </label>

          </div>
          <div v-else>
            <div v-for="model in question.answers" v-bind:key="model.uid"
                 :style="{'display': question.config.display_answers_inline ? 'inline' : 'block'}">

              <label :for="question.uid"
                     v-bind:class="{ selected: model.selected }"
                     v-bind:id="'answer_label_' + model.uid"
                     v-on:click="setRadio(model.uid)"
                     class="radio visible-xs-block visible-sm-block visible-md-inline-block visible-lg-inline-block"
                     style="padding-bottom:10px;padding-top:10px;display:block;">

                <input style="display:none;" type="radio"
                       :name="question.uid"
                       :v-bind:id="model.uid"
                       :value="model.uid"
                       v-bind:checked="model.selected">

                <div v-if="model.survey_icon_class">
                    <i :class="[model.survey_icon_class, model.selected ? 'selected-custom-icon' : '']"
                      style="padding-bottom:10px;padding-top:10px;"
                      class="custom-radio-icon">
                    </i>
                  <b>{{ model.title }}</b>
                </div>
                <div class="radio__text" v-else
                     :style="{'text-transform': question.config.answers_uppercase ? 'uppercase': ''}" v-bind:id="'answer_text_' + model.uid">
                  <span>{{ model.title }}</span>
                </div>
              </label>
            </div>
          </div>

        <!--<label
                :for="question.uid"
                v-bind:class="{ selected: model.selected }"
                v-on:click="setRadio(model.uid)"
                v-for="model in question.answers" v-bind:key="model.uid"
        >
            {{ model.title }}
            <div class="radio-icon" v-bind:style="{
                    '--radio-icon-checked-path': `url(${radioButtonCheckedPath})`,
                    '--radio-icon-unchecked-path': `url(${radioButtonUncheckedPath})`
                }"></div>
            <input style="display:none;" type="radio"
                   :name="question.uid"
                   :value="model.uid"
                   v-bind:checked="model.selected">
        </label>-->
        <transition name="fade">
          <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
        </transition>
        <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
      </div>

      <!--<label
              :for="question.uid"
              v-bind:class="{ selected: model.selected }"
              v-on:click="setRadio(model.uid)"
              v-for="model in question.answers" v-bind:key="model.uid"
      >
          {{ model.title }}
          <div class="radio-icon" v-bind:style="{
                  '--radio-icon-checked-path': `url(${radioButtonCheckedPath})`,
                  '--radio-icon-unchecked-path': `url(${radioButtonUncheckedPath})`
              }"></div>
          <input style="display:none;" type="radio"
                 :name="question.uid"
                 :value="model.uid"
                 v-bind:checked="model.selected">
      </label>-->
</template>

<script>
import Vue from 'vue';
import Comment from './Comment';

export default {
  name: 'radio',
  props: ['question'],
  data() {
    return {
      answerSelected: false,
      showComment: false,
      commentPlaceholder: false,
      commentName: false,
      radioButtonCheckedPath: false,
      radioButtonUncheckedPath: false
    }
  },
  mounted() {
    this.radioButtonCheckedPath = this.$store.getters.getRadioButtonCheckedPath;
    this.radioButtonUncheckedPath = this.$store.getters.getRadioButtonUnCheckedPath;
  },
  methods: {
    setRadio: function (uid) {
      this.showComment = false;
      this.commentPlaceholder = false;
      this.commentName = false;

      this.$emit("inputClick", uid);

      this.question.answers.forEach((item, index) => {
        if (item.uid === uid) {
          item.selected = true;
          if (item.is_allow_comment) {
            this.showComment = true;
            this.commentPlaceholder = item.comment_placeholder;
            this.commentName = 'comment_' + this.question.uid;
          }
          Vue.set(this.question.answers, index, item);
        } else {
          item.selected = false;
          Vue.set(this.question.answers, index, item);
        }

        this.$emit("checkDependency", uid);
      });
    }
  },
  components: {
    Comment
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .10s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}
</style>
